const projects = [
  {
    image: `${process.env.PUBLIC_URL}/assets/nes.png`,
    title: "NES website",
    type: "web",
    description: "Official website of nes, event organised by E-Cell , NITR",
    url: "https://nes2023.live/",
  },
  {
    image: `${process.env.PUBLIC_URL}/assets/minichess.png`,
    title: "opencv project",
    type: "others",
    description:
      "A python project using opencv and nummpy to recognise shapes, roads, signals and find path for robot",
    url: "https://github.com/Srish-ty/OpenCV-project",
  },
  {
    image: `${process.env.PUBLIC_URL}/assets/chromavision.jpg`,
    title: "Article site backend",
    type: "web",
    description: "backend server for a blog website.",
    url: "https://github.com/Srish-ty/MM-SummerTask-2023-Server",
  },
  {
    image: `${process.env.PUBLIC_URL}/assets/unhealthy_auds.png`,
    title: "Respiratory Audio Signal Processing",
    type: "ml",
    description:
      "An ML project to classify respiratory audio signals based on lung diseases",
    url: "https://github.com/Srish-ty/Respiratory_audioSignal_processing",
  },
  {
    image: `${process.env.PUBLIC_URL}/assets/portfolio.png`,
    title: "Portfolio Website",
    type: "web",
    description: "The portfolio website you are staring at right now!",
    url: "https://github.com/Srish-ty/CyberPunk_theme-Portfolio",
  },
  {
    image: `${process.env.PUBLIC_URL}/assets/hn5.png`,
    title: "HackNITR website",
    type: "web",
    description:
      "Official website of HackNITR, Hackathon organised by GDSC and OpenCode , NITR",
    url: "https://hacknitr.com/",
  },
];

export default projects;
